import { LightningElement, api, wire } from "lwc";
import { LabelsAdapter } from "common/labelsAdapter";
import { flattenOptions } from "common/helpers";

var data$9 = { reset: "Alle löschen", showMore: "Mehr anzeigen (%{count})" };
data$9.reset;
data$9.showMore;

var data$8 = { reset: "Clear all", showMore: "Show More (%{count})" };
data$8.reset;
data$8.showMore;

var data$7 = { reset: "Borrar todo", showMore: "Mostrar más (%{count})" };
data$7.reset;
data$7.showMore;

var data$6 = { reset: "Borrar todo", showMore: "Mostrar más (%{count})" };
data$6.reset;
data$6.showMore;

var data$5 = { reset: "Effacer tout", showMore: "Afficher plus (%{count})" };
data$5.reset;
data$5.showMore;

var data$4 = { reset: "Cancella tutto", showMore: "Mostra di più (%{count})" };
data$4.reset;
data$4.showMore;

var data$3 = { reset: "すべてクリア", showMore: "表示件数を増やす (%{count})" };
data$3.reset;
data$3.showMore;

var data$2 = { reset: "모두 지우기", showMore: "자세히 표시(%{count})" };
data$2.reset;
data$2.showMore;

var data$1 = { reset: "Limpar tudo", showMore: "Mostrar mais (%{count})" };
data$1.reset;
data$1.showMore;

var data = { reset: "全部清除", showMore: "显示更多 (%{count})" };
data.reset;
data.showMore;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

function removeValue(filter, value) {
  if (
    value == null ||
    !filter.multiple ||
    !Array.isArray(filter.value) ||
    Array.isArray(value)
  ) {
    return null;
  }

  // Remove item from array
  const newValue = filter.value.filter((v) => v !== value);

  // Return null if the array is empty
  return newValue.length ? newValue : null;
}
const UNSET_FOCUS_INDEX = -1;
const DEFAULT_FILTER_LIMIT = 9;
class FilterPills extends LightningElement {
  _filters = null;
  _showAllFilters = false;
  _pills = null;
  nextFocusablePillIdx = UNSET_FOCUS_INDEX; // Tracks the next pill to focus on whenever a pill is removed.

  @api get filters() {
    return this._filters;
  }
  get showAllFilters() {
    return this._showAllFilters || this.pillsLength() <= DEFAULT_FILTER_LIMIT;
  }
  set filters(value) {
    this._filters = value;
    this._pills = this.buildPills();
  }
  get pills() {
    return this.showAllFilters
      ? this._pills
      : (this._pills ?? []).slice(0, DEFAULT_FILTER_LIMIT);
  }
  renderedCallback() {
    this.handleFocus();
  }
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  labels = {};
  get labelOptions() {
    return {
      showMore: {
        count: this.pillsLength() - DEFAULT_FILTER_LIMIT,
      },
    };
  }
  pillsLength() {
    return this._pills !== null ? this._pills.length : 0;
  }

  // Convert filter values into individual pills
  buildPills() {
    if (!this.filters) return null;
    const pills = this.filters.reduce((arr, f) => {
      if (f.value) {
        // Handle multiple values
        const values = [].concat(f.value);
        return arr.concat(
          values.map((v) => {
            // Use the option label if it exists either as a top level option or in a group
            const flatOptions = flattenOptions(f.options || []);
            const option = flatOptions.find((o) => o.value === v);
            return {
              ...f,
              key: `${f.label}_${v}`,
              value: v,
              label: (option && option.label) || v,
              filterLabel: f.label,
              onRemove: () => {
                this.handleRemoveValue(f.id, v);
              },
            };
          })
        );
      }
      return arr;
    }, []);
    return pills.length ? pills : null;
  }
  handleReset() {
    this.dispatchEvent(new CustomEvent("reset"));
  }
  handleShowMore() {
    this._showAllFilters = true;
  }
  handleRemoveValue(id, value) {
    const filter = this.filters
      ? this.filters.find((f) => f.id === id)
      : undefined;
    const newValue = filter ? removeValue(filter, value) : null;
    const event = {
      detail: {
        id,
        value: newValue,
      },
    };
    this.setNextFocusablePillIdx(id, value);
    this.dispatchEvent(new CustomEvent("filter", event));
  }
  setNextFocusablePillIdx(id, value) {
    if (this.pills) {
      const removedPillIdx = this.pills.findIndex(
        (pill) => pill.value === value && pill.id === id
      );
      this.nextFocusablePillIdx = removedPillIdx;

      // if the last pill was removed the focus should be moved to the last but one pill
      if (this.nextFocusablePillIdx === this.pills.length - 1) {
        this.nextFocusablePillIdx = this.pills.length - 2;
      }
    }
  }
  handleFocus() {
    if (this.nextFocusablePillIdx >= 0) {
      const nextFocusablePill = this.pillElements.item(
        this.nextFocusablePillIdx
      );
      if (nextFocusablePill) nextFocusablePill.focus();
      this.nextFocusablePillIdx = UNSET_FOCUS_INDEX;
    } else if (!this.pills?.length) {
      this.dispatchEvent(
        new CustomEvent("focuspreviouselement", {
          bubbles: true,
          composed: true,
        })
      );
    }
  }
  get pillElements() {
    return this.template.querySelectorAll(".pills .pill");
  }
}

export default FilterPills;
export { removeValue };
